module.exports = __webpack_public_path__ + "static/media/leadManager_icon.0825c5b5.svg";